import { render, staticRenderFns } from "./CostCategoriesTable.vue?vue&type=template&id=36cff9ac&scoped=true&"
import script from "./CostCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./CostCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./CostCategoriesTable.vue?vue&type=style&index=0&id=36cff9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cff9ac",
  null
  
)

export default component.exports